export const FAQ_ROUTE = '/faq-list'
export const FAQ_ADD_ROUTE = '/faq-add'
export const FAQ_EDIT_ROUTE = '/faq-edit'
export const MANAGE_CATEGORY_ROUTE = '/manage-category'
